// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2k-1";
export var rateTableServiceLevelDropdown = "_2k-3";
export var rateTableTypeDropdown = "_2k-0";
export var rateTableValueModeDropdown = "_2k-2";